export default __webpack_public_path__ + "static/media/H4006.1.e3a7fee1.mp3";